<template>
  <el-dialog
    append-to-body
    width="800px"
    :title="`${isChange ? '编辑视频' : '发布视频'}`"
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    top="3vh"
  >
    <el-form
      v-loading="loading"
      element-loading-text="加载中…"
      ref="elFormDom"
      label-width="110px"
      label-position="right"
      :model="form.data"
      :rules="form.rules"
    >
      <el-form-item prop="title" label="标题">
        <el-input
          placeholder="请输入标题"
          v-model="form.data.title"
          maxlength="50"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item prop="category" label="分类">
        <el-select v-model="form.data.category" placeholder="请选择" clearable>
          <el-option label="行业分析" :value="1"></el-option>
          <el-option label="求职技巧" :value="2"></el-option>
          <el-option label="技能培训" :value="3"></el-option>
          <el-option label="人才政策" :value="4"></el-option>
        </el-select>
      </el-form-item>
      <!-- <el-form-item prop="title" label="标题">
        <el-input
          placeholder="请输入标题"
          v-model="form.data.title"
          maxlength="50"
          clearable
        ></el-input>
      </el-form-item> -->
      <el-form-item prop="desc" label="描述">
        <el-input
          placeholder="请输入200字以内的描述"
          v-model="form.data.desc"
          type="textarea"
          maxlength="200"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item prop="video" label="视频">
        <div style="width: 170px">
          <el-upload
            class="avatar-uploader-image"
            :limit="1"
            action=""
            ref="videoUploadDom"
            :headers="{ token: token }"
            :show-file-list="false"
            :before-upload="handleBeforeUpload"
            :http-request="httpRequest"
            :on-exceed="handleExceed"
            accept="video/mp3, video/mp4, video/ogg, video/flv, video/avi, video/wmv, video/rmvb, video/mov"
          >
            <template v-if="form.data.video">
              <video
                :src="form.data.video"
                controls
                height="80px"
                width="160px"
              ></video>
            </template>
            <template v-else>
              <i class="el-icon-plus avatar-uploader-icon"></i>
              <div
                style="top: 55px; color: #999; left: 65px"
              >
                时长建议10分钟以内
              </div>
            </template>
          </el-upload>
          <span v-if="!!form.data.video" class="delVideo" @click="delVideo"
            ><i class="el-icon-delete"></i>删除视频</span
          >
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <el-row type="flex" justify="end">
        <el-button @click="toggle(false)">取消</el-button>
        <el-button
          type="primary"
          :loading="form.loading"
          :disabled="form.loading"
          @click="confirm"
          >确定</el-button
        >
      </el-row>
    </template>
    <el-dialog :visible.sync="dialogVisible" :modal="false">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </el-dialog>
</template>

<script>
import * as qiniu from "qiniu-js";
import { getStorage } from "@/storage";
import MyEditor from "@/components/MyEditor.vue";
export default {
  name: "NotifyEdit",
  components: {
    MyEditor,
  },
  data() {
    return {
      token: getStorage("token"),
      visible: false,
      isChange: false,
      loading: false,
      form: {
        loading: false,
        data: {
          title: "",
          category: "",
          desc: "",
          video: "",
          cover: "",
        },
        rules: {
          category: [{ required: true, message: "必填", trigger: "change" }],
          video: [{ required: true, message: "必填", trigger: "change" }],
          // desc: [{ required: true, message: "必填", trigger: "change" }],
          title: [{ required: true, message: "必填", trigger: "change" }],
        },
      },
      dialogVisible: false,
      dialogImageUrl: "",
      fileList: [],
      file: [],
    };
  },
  methods: {
    handleBeforeUpload(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const video = document.createElement("video");
          video.preload = "metadata";

          video.onloadedmetadata = () => {
            window.URL.revokeObjectURL(video.src);
            const duration = video.duration;
            console.log(duration, "duration");
            if (duration > 600) {
              // 视频时长限制，例如10分钟
              this.$message.warning("上传的视频时长不能超过10分钟！");
              return;
              reject();
            } else {
              resolve(file);
            }
          };

          video.onerror = () => {
            this.$message.error("视频文件读取出错！");
            reject();
          };

          video.src = e.target.result;
        };
        reader.onerror = () => {
          this.$message.error("文件读取出错！");
          reject();
        };

        reader.readAsDataURL(file);
      });
    },
    httpRequest(file) {
      // console.log(file, "file");
      // let formData = new FormData();
      // formData.append("file", file.file);
      // this.$http
      //   .post("/common/qiniu/uploadFile", { formData, type: "upload" })
      //   .then((res) => {
      //     this.form.data.video = res.data.all_path_url;
      //     this.$refs.elFormDom.clearValidate();
      //     // 提取第一帧并上传为封面
      //     this.uploadVideoCover(file.file);
      //   });
      // const lastDotIndex = filename.lastIndexOf('.');
      // if (lastDotIndex < 1) return '';
      // return filename.slice(lastDotIndex + 1);
      let name = file.file.name;
      const lastDotIndex = name.lastIndexOf('.');
      let name_ = name.slice(lastDotIndex + 1);
      let _that = this;
      _that.form.loading = true;
      _that.loading = true;
      this.$http
        .post("/common/qiniu/getUpToken", { ext: name_ })
        .then((res) => {
          if (res.code == 1) {
            _that.uploadKey = res.data.key;
            _that.uploadToken = res.data.token;

            const qiniuUploadInfo = {
              file: file.file, //文件对象
              key: _that.uploadKey, //文件资源名称
              token: _that.uploadToken, //从后端获取的uplodaToken
            };
            console.log(qiniuUploadInfo, "002");
            const putExtra = {
              fname: "", // 文件原文件名
              params: {}, // 用来放置自定义变量
              mimeType: null, // 用来限制上传文件类型，为 null 时表示不对文件类型限制；eg: ["image/png", "image/jpeg"]
            };
            const config = {
              useCdnDomain: true, //cdn加速
              region: qiniu.region.z0, //区域
            };

            const observable = qiniu.upload(
              qiniuUploadInfo.file,
              qiniuUploadInfo.key,
              qiniuUploadInfo.token,
              putExtra,
              config
            );

            //上传开始
            observable.subscribe({
              next(res) {
                // console.log("next", res);
              },
              error(err) {
                console.log("err", err);
              },
              complete(res) {
                //来到这里就是上传成功了。。
                console.log(res, "******************");
                _that.form.data.video = `https://qn.cdn.jszhr.com/${res.key}`;
                _that.form.loading = false;
                _that.uploadVideoCover(file.file);
              },
            });
          }
        }).catch(() =>{
          _that.delVideo();
          _that.form.loading = false;
          _that.loading = false;
        })
        .finally(() =>{
          _that.form.loading = false;
          _that.loading = false;
        })
    },
    // 提取视频第一帧并上传为封面
    uploadVideoCover(videoFile) {
      console.log('拿封面')
      const video = document.createElement("video");
      video.preload = "metadata";
      video.muted = true;
      video.playsInline = true;
      video.onloadeddata = () => {
        // 跳转到第一帧（0.1秒处，避免黑屏）
        video.currentTime = 0.1;
      };
      video.onseeked = () => {
        const canvas = document.createElement("canvas");
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
          window.URL.revokeObjectURL(video.src);
          // 上传封面图
          let coverFormData = new FormData();
          coverFormData.append("file", blob, "cover.jpg");
          this.$http
            .post("/common/qiniu/uploadFile", {
              formData: coverFormData,
              type: "upload",
            })
            .then((res) => {
              this.form.data.cover = res.data.all_path_url;
            });
        }, "image/jpeg");
      };
      video.onerror = () => {
        console.error("视频封面提取失败");
      };
      video.src = URL.createObjectURL(videoFile);
    },
    delVideo() {
      this.$refs.videoUploadDom.clearFiles()
      this.form.data.video = "";
      this.form.data.cover = "";
      this.fileList = [];
      this.file = [];
    },
    handleExceed(files, fileList) {
      this.$message.warning("最多上传一个文件");
    },
    // 获取详情
    getDetail(row) {
      this.isChange = true;
      this.form.data.title = row.title;
      this.form.data.category = row.category;
      this.form.data.desc = row.desc;
      this.form.data.id = row.id;
      this.form.data.video = row.video || "";
      this.form.data.cover = row.cover || "";
    },
    reset(done) {
      this.isChange = false;
      this.form.data.title = "";
      this.form.data.category = "";
      this.form.data.desc = "";
      this.form.data.video = "";
      this.form.data.cover = "";
      this.fileList = [];
      this.file = [];
      this.delVideo()
      this.$nextTick(() => {
        this.$refs.elFormDom.clearValidate();
        done && done();
      });
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    handleChange(file, fileList) {
      this.file = fileList;
    },

    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleRemove(file) {
      this.fileList.splice(this.file.indexOf(file), 1);
      this.file.splice(this.file.indexOf(file), 1);
    },
    beforeAvatarUpload(file) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      if (!isLt5M) {
        this.$message.error("上传文件大小不能超过 5MB!");
      }
      return isLt5M;
    },
    // 提交
    confirm() {
      // if (!this.form.data.video) {
      //   this.$message.warning("请上传视频");
      //   return;
      // }
      this.$refs.elFormDom.validate((valid) => {
        if (valid) {
          if (!this.form.data.video) {
            this.$message.warning("视频不能为空");
            return;
          }
           this.form.loading = true;
          let apiUrl = !this.isChange
            ? "/admin/article/add"
            : "/admin/article/edit";
          let params = {
            ...this.form.data,
            type: 1,
          };
          this.$http
            .post(apiUrl, params)
            .then((res) => {
              if (res.code === 1) {
                this.toggle(false);
                this.$emit("refresh");
              } else {
                this.$message.error(res.msg);
              }
            })
            .finally(() => {
              this.form.loading = false;
            });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
// 上传视频样式
.avatar-uploader-image .el-icon-plus {
  width: 160px;
  height: 80px;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
}
.avatar-uploader-image .el-icon-plus:hover {
  border: 1px dashed #2cb167;
}
.avatar-uploader-image .avatar {
  width: 160px;
  height: 80px;
}
.avatar-uploader-image .avatar-uploader-icon {
  line-height: 80px !important;
  font-size: 28px;
  color: #8c939d;
  background-color: #fbfdff;
}
.delVideo {
  margin-left: 40px;
  cursor: pointer;
  color: #999;
  font-size: 14px;
}
.delVideo:hover {
  color: #2cb167;
}
</style>
